import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"border-radius":"15px","background":"white"}
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div><p class=\"search_system_selection\"> от ведущих маркетплейсов </p></div><ul class=\"search_system_list\"><li class=\"js_tab_trigger_1 logo_box_item active\" data-tab=\"1\"><div class=\"tip\"><a target=\"_blank\" href=\"https://level.travel/?aflt=UTravell\">Level.Travel</a> — это автоматизированная система поиска туров от всех надежных туроператоров и их покупки в режиме онлайн, без участия турагента. Система Level.travel интегрирована напрямую с ведущими туроператорами России, поэтому все цены на сайте на 100% финальны и актуальны и все туры доступны для бронирования онлайн (без звонков в колл-центр). <span class=\"close\"></span></div><img style=\"opacity:1;\" class=\"lazyload\" data-src=\"/local/templates/travel/img/leveltravel.png\" alt=\"\"></li><li class=\"js_tab_trigger_1 logo_box_item\" data-tab=\"5\"><div class=\"tip\"><a target=\"_blank\" href=\"https://tp.media/r?marker=200556&amp;trs=29902&amp;p=5002&amp;u=https%3A%2F%2Fsletat.ru\">Слетать.ру</a> — сервис сравнения туров от всех крупных туроператоров России. На sletat.ru можно выбрать путешествие на море, горнолыжный курорт, экскурсионный тур, забронировать в режиме онлайн и оплатить банковской картой.Быстрый поиск: 1000 вариантов от всех туроператоров за пару секунд. Компания Слетать.ру осуществляет свою деятельность с 2010 года и является одним из лидеров отрасли. <span class=\"close\"></span></div><img style=\"opacity:1;\" alt=\"Sletat RU\" class=\"lazyload\" data-src=\"/local/templates/travel/img/logo_min/sletat_ru.jpg\"></li><li class=\"js_tab_trigger_1 logo_box_item\" data-tab=\"2\"><div class=\"tip\"><a target=\"_blank\" href=\"https://tp.media/r?marker=200556&amp;trs=29902&amp;p=771&amp;u=https%3A%2F%2Ftravelata.ru%2F\">Travelata.ru</a> — это поиск самых выгодных туров. К проекту подключено более 120 туроператоров, и Травелата гарантирует, что эти туры можно купить по самым выгодным условиям. <span class=\"close\"></span></div><img style=\"opacity:1;\" class=\"lazyload\" data-src=\"/local/templates/travel/img/travelata.png\" alt=\"\"></li><li class=\"js_tab_trigger_1 logo_box_item\" data-tab=\"3\"><div class=\"tip\"><a target=\"_blank\" href=\"https://tp.media/r?marker=200556&amp;trs=29902&amp;p=1094&amp;u=https%3A%2F%2Fwww.onlinetours.ru%2F\">Onlinetours</a> — популярный онлайн-сервис по продаже туров от ведущих туроператоров, более чем в 80 стран мира. Миллионы турпакетов, в которые входят авиабилеты, проживание в отеле, медицинская страховка и трансфер. <span class=\"close\"></span></div><img style=\"opacity:1;\" class=\"lazyload\" data-src=\"/local/templates/travel/img/onlinetours.png\" alt=\"\"></li></ul>", 2)
const _hoisted_4 = { class: "d-sm-block d-md-none" }
const _hoisted_5 = { class: "row gy-2" }
const _hoisted_6 = { class: "col-12 form-control" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "#17181A",
  height: "19"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m20.5 20.5-6-6m2-4.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z" })
], -1)
const _hoisted_9 = { class: "col-12 form-control" }
const _hoisted_10 = { class: "col-12 form-control" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "col-12 form-control" }
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = { class: "d-none d-md-block" }
const _hoisted_15 = { class: "input-group" }
const _hoisted_16 = { class: "form-control" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "#17181A",
  height: "19"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m20.5 20.5-6-6m2-4.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z" })
], -1)
const _hoisted_19 = { class: "form-control" }
const _hoisted_20 = { class: "form-control" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "form-control" }
const _hoisted_23 = { class: "form-control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountryPicker = _resolveComponent("CountryPicker")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_NumberPicker = _resolveComponent("NumberPicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_CountryPicker, {
              onInput: _ctx.writeTo,
              placeholder: "Страна или курорт",
              modelValue: _ctx.to,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.to) = $event))
            }, null, 8, ["onInput", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_DatePicker, {
            locale: "ru",
            minDate: new Date(),
            modelValue: _ctx.start_date,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.start_date) = $event)),
            enableTimePicker: false,
            autoApply: "",
            format: _ctx.formatDate
          }, null, 8, ["minDate", "modelValue", "format"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_CountryPicker, {
              onInput: _ctx.writeFrom,
              placeholder: "Откуда",
              decl: true,
              modelValue: _ctx.from,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.from) = $event))
            }, null, 8, ["onInput", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_NumberPicker, {
              onInput: _ctx.writeAdultsCount,
              class: "w-100 h-100",
              modelValue: _ctx.adults_count,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.adults_count) = $event)),
              labels: ['взрослый','взрослых','взрослых']
            }, null, 8, ["onInput", "modelValue"]),
            _createVNode(_component_NumberPicker, {
              onInput: _ctx.writeNightsCount,
              class: "ms-2 w-100 h-100",
              modelValue: _ctx.nights_count,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.nights_count) = $event)),
              labels: ['ночь','ночи','ночей']
            }, null, 8, ["onInput", "modelValue"])
          ])
        ]),
        _createElementVNode("button", {
          class: "fw-bold form-control bg-gradient text-white",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.findTours && _ctx.findTours(...args)))
        }, " Найти ")
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_CountryPicker, {
              onInput: _ctx.writeTo,
              placeholder: "Страна или курорт",
              modelValue: _ctx.to,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.to) = $event))
            }, null, 8, ["onInput", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_DatePicker, {
            locale: "ru",
            minDate: new Date(),
            modelValue: _ctx.start_date,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.start_date) = $event)),
            enableTimePicker: false,
            autoApply: "",
            format: _ctx.formatDate,
            onInput: _ctx.writeStartDate
          }, null, 8, ["minDate", "modelValue", "format", "onInput"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_CountryPicker, {
              onInput: _ctx.writeFrom,
              placeholder: "Откуда",
              decl: true,
              modelValue: _ctx.from,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.from) = $event))
            }, null, 8, ["onInput", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_NumberPicker, {
            onInput: _ctx.writeAdultsCount,
            class: "w-100 h-100",
            modelValue: _ctx.adults_count,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.adults_count) = $event)),
            labels: ['взрослый','взрослых','взрослых']
          }, null, 8, ["onInput", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_NumberPicker, {
            onInput: _ctx.writeNightsCount,
            class: "w-100 h-100",
            modelValue: _ctx.nights_count,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.nights_count) = $event)),
            labels: ['ночь','ночи','ночей']
          }, null, 8, ["onInput", "modelValue"])
        ]),
        _createElementVNode("button", {
          class: "bg-gradient text-white m-0 pretty_button fw-bold",
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.findTours && _ctx.findTours(...args)))
        }, " Найти ")
      ])
    ])
  ]))
}